// extracted by mini-css-extract-plugin
module.exports = {"h5xzaxn":"h5xzaxn"};